import { render, staticRenderFns } from "./CertifyCompany.vue?vue&type=template&id=65851e88&scoped=true&"
import script from "./CertifyCompany.vue?vue&type=script&lang=js&"
export * from "./CertifyCompany.vue?vue&type=script&lang=js&"
import style0 from "./CertifyCompany.vue?vue&type=style&index=0&id=65851e88&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "65851e88",
  null
  
)

export default component.exports